import { FC, SVGProps } from 'react';
import { Icon, LabelProps, Tooltip } from '@gravity-ui/uikit';
import {
    TriangleExclamation,
    Arrows3RotateRight,
    CloudCheck,
    CircleDashed,
    Check,
} from '@gravity-ui/icons';
import { Label } from '@gravity-ui/uikit';
import { statusesT } from '../../../i18n';

export enum VideoStatus {
    WaitUploading = 'WAIT_UPLOADING',
    Processing = 'PROCESSING',
    Ready = 'READY',
    Published = 'PUBLISHED',
    Error = 'ERROR',
}

const VideoStatusLabelTheme: Record<VideoStatus, LabelProps['theme']> = {
    [VideoStatus.Error]: 'danger',
    [VideoStatus.Processing]: 'info',
    [VideoStatus.Published]: 'success',
    [VideoStatus.Ready]: 'success',
    [VideoStatus.WaitUploading]: 'info',
};

const getVideoStatusName = (status: VideoStatus): string => {
    switch (status) {
        case VideoStatus.Error:
            return statusesT('error');
        case VideoStatus.Processing:
            return statusesT('processing');
        case VideoStatus.Published:
            return statusesT('published');
        case VideoStatus.Ready:
            return statusesT('ready');
        case VideoStatus.WaitUploading:
            return statusesT('waitUploading');
        default:
            return status;
    }
};

const videoStatusToIconComponent: Record<
    VideoStatus,
    (props: SVGProps<SVGSVGElement>) => JSX.Element
> = {
    [VideoStatus.Error]: TriangleExclamation,
    [VideoStatus.Processing]: Arrows3RotateRight,
    [VideoStatus.Published]: CloudCheck,
    [VideoStatus.Ready]: Check,
    [VideoStatus.WaitUploading]: CircleDashed,
};

interface VideoStatusLabelProps {
    status: VideoStatus;
    isMobile?: boolean;
}

const VideoStatusIcon: FC<{ status: VideoStatus }> = ({ status }) => {
    const svg = videoStatusToIconComponent[status];
    return (
        <Tooltip content={getVideoStatusName(status)}>
            <Icon data={svg} />
        </Tooltip>
    );
};

export const VideoStatusLabel: FC<VideoStatusLabelProps> = ({ status, isMobile }) => {
    const icon = isMobile ? <VideoStatusIcon status={status} /> : null;
    const text = isMobile ? null : getVideoStatusName(status);
    return (
        <Label theme={VideoStatusLabelTheme[status]} icon={icon}>
            {text}
        </Label>
    );
};
